export default "__VITE_ASSET__Dxi463am__"